var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5938,
    cy: 80.4265,
    r: 80,
    fill: "#BAADAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.6141 38.7599C69.1564 38.7599 59.7544 48.1294 59.7544 59.5871C59.7544 71.0448 69.1564 80.4469 80.6141 80.4469C92.0718 80.4469 101.433 71.0448 101.433 59.5871C101.433 48.1294 92.0718 38.7599 80.6141 38.7599ZM63.9377 84.5977C51.4283 84.5977 38.9271 92.9318 38.9271 105.417V114.679C39.7211 119.889 43.0942 122.101 47.2694 122.093H113.926C118.102 122.102 120.858 118.616 122.26 114.679V105.417C122.269 88.7648 109.767 84.5977 97.2499 84.5977H63.9377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.d3e47ce8a369b0fba8ad7d0ad066dd54.svg";
export { ForwardRef as ReactComponent };